import React, { forwardRef } from "react"

import { cn } from "@/lib/utils"
import { Link } from "@/components/ui/atoms"
import { TNavItem } from "@/components/ui/organisms"

export interface IFooterTopCardProps {
  asChild?: boolean
  className?: string
  title: string
  buttons?: TNavItem[]
  iframe?: string
}

const FooterTopCard = forwardRef<HTMLDivElement, IFooterTopCardProps>(
  ({ className, title, iframe, buttons, ...props }, ref) => {
    return (
      <div
        className={cn(
          "w-full rounded-100 bg-neutral-100 p-6 md:w-6/12 lg:w-[620px] lg:basis-[620px] lg:p-7",
          className
        )}
        ref={ref}
        {...props}
      >
        <h3 className="heading-m mb-7">{title}</h3>
        {iframe ? (
          <iframe
            width="100%"
            height="48px"
            src={iframe}
            title="Formulaire d'inscription à la newsletter"
          ></iframe>
        ) : buttons ? (
          <div className="flex justify-end">
            {buttons.map((item) => {
              return (
                <Link
                  chapters={["Footer", item.title]}
                  key={item.codename}
                  href={item.href}
                  id={item.codename}
                >
                  {item.title}
                </Link>
              )
            })}
          </div>
        ) : null}
      </div>
    )
  }
)
FooterTopCard.displayName = "FooterTopCard"

export default FooterTopCard
